"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getParsedLocationAwarePurchaseMotions = exports.getLocationAwarePurchaseMotionData = exports.getPurchaseMotionData = void 0;

var _purchaseMotionApi = require("self-service-api/core/api/purchaseMotionApi");

var _validators = require("self-service-api/core/validators");

var _availableTrialsAdapter = _interopRequireDefault(require("self-service-api/adapters/availableTrialsAdapter"));

var _locationAwarePurchaseMotionsAdapter = require("../adapters/locationAwarePurchaseMotionsAdapter");

var _adaptPurchaseMotionResponse = function _adaptPurchaseMotionResponse(purchaseMotionMetaData) {
  var availableTrials = purchaseMotionMetaData.availableTrials,
      customerCurrencyCode = purchaseMotionMetaData.customerCurrencyCode,
      productBasedOffers = purchaseMotionMetaData.productBasedOffers,
      parcels = purchaseMotionMetaData.parcels,
      subscriptionTerms = purchaseMotionMetaData.subscriptionTerms,
      merchandiseIdsTreatedAsOwned = purchaseMotionMetaData.merchandiseIdsTreatedAsOwned;
  return {
    availableTrials: (0, _availableTrialsAdapter.default)(availableTrials),
    customerCurrencyCode: customerCurrencyCode,
    productBasedOffers: productBasedOffers,
    parcels: parcels,
    subscriptionTerms: subscriptionTerms,
    merchandiseIdsTreatedAsOwned: merchandiseIdsTreatedAsOwned
  };
};

var getPurchaseMotionData = function getPurchaseMotionData() {
  var merchandiseIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  merchandiseIds.forEach(_validators.validateMerchandiseId);
  return (0, _purchaseMotionApi.fetchPurchaseMotionData)(merchandiseIds).then(function (purchaseMotionData) {
    return Object.assign({}, _adaptPurchaseMotionResponse(purchaseMotionData), {
      purchaseMotions: purchaseMotionData.purchaseMotions
    });
  });
};

exports.getPurchaseMotionData = getPurchaseMotionData;

var getLocationAwarePurchaseMotionData = function getLocationAwarePurchaseMotionData(_ref) {
  var _ref$merchandiseIds = _ref.merchandiseIds,
      merchandiseIds = _ref$merchandiseIds === void 0 ? [] : _ref$merchandiseIds,
      locations = _ref.locations,
      apiGetter = _ref.apiGetter,
      _ref$fetchMetaData = _ref.fetchMetaData,
      fetchMetaData = _ref$fetchMetaData === void 0 ? true : _ref$fetchMetaData;

  if (!locations || locations.length === 0) {
    throw new Error('Need to specify location');
  }

  merchandiseIds.forEach(_validators.validateMerchandiseId);
  return (0, _purchaseMotionApi.fetchLocationAwarePurchaseMotionData)({
    merchandiseIds: merchandiseIds,
    locations: locations,
    apiGetter: apiGetter,
    fetchMetaData: fetchMetaData
  }).then(function (response) {
    return Object.assign({}, response, {}, fetchMetaData && {
      metadata: _adaptPurchaseMotionResponse(response.metadata)
    });
  });
};

exports.getLocationAwarePurchaseMotionData = getLocationAwarePurchaseMotionData;

var getParsedLocationAwarePurchaseMotions = function getParsedLocationAwarePurchaseMotions(_ref2) {
  var merchandiseIds = _ref2.merchandiseIds,
      locations = _ref2.locations,
      apiGetter = _ref2.apiGetter,
      fetchMetaData = _ref2.fetchMetaData;
  return function (_ref3) {
    var location = _ref3.location,
        merchandiseId = _ref3.merchandiseId;
    return getLocationAwarePurchaseMotionData({
      merchandiseIds: merchandiseIds,
      locations: locations,
      apiGetter: apiGetter,
      fetchMetaData: fetchMetaData
    }).then(function (purchaseMotionData) {
      return (0, _locationAwarePurchaseMotionsAdapter.locationAwarePurchaseMotionsAdapter)(purchaseMotionData, location, merchandiseId);
    });
  };
};

exports.getParsedLocationAwarePurchaseMotions = getParsedLocationAwarePurchaseMotions;